import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootContainer: {
        height: '150px',
        borderRadius: '20px',
        // filter: 'drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.25))',
        boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.25)',
        margin: '0px 0 20px 0',
        flexDirection: 'column',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            height: '80px'
        },
    },
    rootContainerImage: {
        width: '150px',
        '& > div': {
            height: '150px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '& > div > img': {
            maxWidth: '100%',
            borderRadius: '20px 0px 0px 20px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '80px',
            '& > div': {
                height: '80px',
            },
        },
    },
    rootContainerContent: {
        width: 'calc(100% - 150px)',
        padding: '15px 20px 25px 20px',
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 80px)',
            padding: '5px 20px',
        },
    },
    title: {
        fontSize: themeCommon.fontSize22px,
        color: '#2F2F2F',
        fontFamily: themeCommon.RobotoBold,
        // [theme.breakpoints.up('xl')]: {
        //     fontSize: themeCommon.fontSize20px,
        // },
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize10px,
        },
    },
    rootContainerDescription: {
        marginBottom: '15px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '5px',
        },
    },
    description: {
        fontSize: themeCommon.fontSize18px,
        color: '#2F2F2F',
        // [theme.breakpoints.down('xl')]: {
        //     fontSize: themeCommon.fontSize16px,
        // },
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize12px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize10px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize8px,
        },
    },
    rootProgressBar: {
        height: '15px !important',
        background: '#D7D7D7 !important',
        opacity: 0.6,
        borderRadius: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '10px !important',
        },
    },
    barProgressBar: {
        height: '15px',
        background: `${themeCommon.lightBlue} !important`,
        // opacity: 0.6,
        borderRadius: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '10px',
        },
    },
}), {
    name: 'LCCategoryHeadContainer',
    index: 1,
})

export default useStyles